export enum EAIModels {
	claude = 'claude-3-5-sonnet-20240620',
	groq = 'llama3-8b-8192',
	openai_gpt4o = 'gpt-4o',
	openai_gpt4oMini = 'gpt-4o-mini',
	openai_gpt4_1 = 'gpt-4.1',
	openai_gpt4_1_mini = 'gpt-4.1-mini',
	openai_gpt4_1_nano = 'gpt-4.1-nano',
	claude_3_7_sonnet = 'claude-3-7-sonnet-latest',
	claude_3_5_haiku = 'claude-3-5-haiku-latest',
	claude_3_5_sonnet = 'claude-3-5-sonnet-latest',
}

export const EAIModelsData = [
	{
		value: EAIModels.openai_gpt4_1,
		label: 'OpenAI: GPT 4.1 (Smartest)',
	},
	{
		value: EAIModels.openai_gpt4_1_mini,
		label: 'OpenAI: GPT 4.1 mini (Smart, Faster)',
	},
	{
		value: EAIModels.openai_gpt4_1_nano,
		label: 'OpenAI: GPT 4.1 nano (Fastest)',
	},
	// {
	//   value: EAIModels.claude_3_7_sonnet,
	//   label: 'Anthropic: Claude 3.7 Sonnet (Balanced, Efficient)',
	// },
	// {
	//   value: EAIModels.claude_3_5_haiku,
	//   label: 'Anthropic: Claude 3.5 Haiku (Rapid Response, Streamlined)',
	// },
	// {
	//   value: EAIModels.claude_3_5_sonnet,
	//   label: 'Anthropic: Claude 3.5 Sonnet (Cost-Effective Performance)',
	// },
];
